import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { Picture } from "@/components/wpl/image/src";

export const QuotationsAdornment = (props: PropsWithChildren) => {
    return (
        <div
            css={css({
                width: "100%",
                position: "relative"
            })}
        >
            <span
                css={css({
                    position: "absolute",
                    insetBlockStart: 285,
                    insetInlineStart: -185,
                    [media.below.md]: {
                        display: "none"
                    }
                })}
            >
                <LeftQuotation />
            </span>

            {props.children}

            <span
                css={css({
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineEnd: -165,
                    [media.below.md]: {
                        display: "none"
                    }
                })}
            >
                <RightQuotation />
            </span>
        </div>
    );
};

const LeftQuotation = () => (
    <Picture
        image={{
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/02m24o230o077mu3rxv7gm30nj77wqii.svg",
            alt: "Quotation left"
        }}
    />
);

const RightQuotation = () => (
    <Picture
        image={{
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/50x33lwtmm1hnd8x717wk316dthyw741.svg",
            alt: "Quotation right"
        }}
    />
);
